export const deAT = {
  app: {
    categories: {
      convectors: 'Konvektoren',
      decorative: 'Designheizkörper',
      electric: 'E-Heizkörper',
      panels: 'Flachheizkörper',
      towel: 'Badheizkörper',
    },
    categoryLabel: 'Kategorie',
    categoryPlaceholder: 'Kategorie auswählen',
    errorCategories: 'Kategorien konnten nicht geladen werden.',
    errorPanels: 'Heizkörper konnten nicht geladen werden.',
    loadingCategories: 'Kategorien werden geladen...',
    loadingPanels: 'Heizkörper werden geladen...',
    panelLabel: 'Heizkörper',
    panelPlaceholder: 'Heizkörper auswählen',
    titles: {
      convectors: 'Konvektor-Kalkulator',
      decorative: 'Designheizkörper-Kalkulator',
      electric: 'Elektroheizkörper-Kalkulator',
      panels: 'Flachhheizkörper-Kalkulator',
      towel: 'Badheizkörper-Kalkulator',
    },
  },
  calc: {
    actionButton: 'Berechnete Artikel anzeigen',
    boost: 'Boost-Modus',
    calculateRequiredButton: 'Benötigte Watt berechnen',
    calculating: 'Wird berechnet...',
    comfort: 'Komfortmodus',
    downloadLabel: 'Daten herunterladen ({count})',
    emptyResults: 'Noch keine Ergebnisse.',
    errorMatch: 'Ergebnisse konnten nicht berechnet werden.',
    errorTypes: 'Heizkörpertypen konnten nicht geladen werden.',
    flowTemp: 'Vorlauf C°',
    height: 'Höhe',
    length: 'Länge',
    loadingTypes: 'Typen werden geladen...',
    modeLabel: 'Modus',
    modes: {
      cooling: 'Kühlen',
      heating: 'Heizen',
    },
    radiatorType: 'Heizkörpertyp',
    requiredWatts: 'Benötigte Leistung [W]',
    resultsMessage: '{count} Artikel für die ausgewählten Optionen verfügbar.',
    returnTemp: 'Rücklauf C°',
    roomTemp: 'Raumtemperatur C°',
    selectAllLabel: 'Alle Artikel auswählen',
    selectItemLabel: 'Artikel zum Herunterladen auswählen',
    selectPanel: 'Wählen Sie einen Heizkörper zur Berechnung.',
    standby: 'Standby-Modus',
    tableHeaders: {
      calculatedWattage: 'Leistung',
      co2Equivalent: 'CO2-Äquivalent pro kg oder Material',
      depth: 'Tiefe [mm]',
      description: 'Artikelbeschreibung',
      dop: 'DoP',
      eudop: 'EU DoP',
      height: 'Höhe [mm]',
      itemId: 'Artikelnummer',
      length: 'Länge [mm]',
      waterContent: 'Wasserinhalt',
      weight: 'Gewicht',
    },
    title: 'Berechnungen',
    tolerance: 'Toleranz',
    typeCooling: 'Kühlen',
    typeGroupLabel: 'Typ',
    typeHeating: 'Heizen',
  },
  deVariantRadiator: {
    depth: 'Bautiefe',
    description:
      'Berechnung der Wärmeleistung für Bestandsheizkörper (Stahlrohre, Stahlrippen, Gussradiatoren).',
    elements: 'Anzahl Glieder',
    height: 'Bauhöhe',
    resultLabelTemplate: 'Wärmeleistung bei Systemtemperatur {temp}',
    select: 'Auswählen',
    temperature: 'Systemtemperatur',
    type: 'Bauart',
  },
  existingRadiator: {
    description:
      'Dieser Kalkulator dient nur zur überschlägigen Kalkulation und zur Orientierung. Bitte lassen Sie sich vor dem Kauf eine genaue Berechnung von Ihrem Fachbetrieb erstellen!',
    height: 'Heizkörperhöhe',
    length: 'Heizkörperlänge',
    resultLabelTemplate: 'Wärmeleistungsbedarf, berechnet bei Systemtemperatur {temp}',
    select: 'Auswählen',
    temperature: 'Systemtemperatur',
    type: 'Heizkörpertyp',
  },
  matrixCalc: {
    axisHeight: 'Höhe (mm)',
    axisLength: 'Länge (mm)',
    axisType: 'Typ',
    calculateButton: 'Calculate',
    displayLabel: 'Anzeige',
    exportExcel: 'Als Excel exportieren',
    exportPdf: 'Als PDF exportieren',
    print: 'Drucken',
    hideOutOfRange: 'Artikel außerhalb des Bereichs ausblenden',
    showAll: 'Alle anzeigen',
    loading: 'Loading...',
    lockHeight: 'Höhe',
    lockLabel: 'Dimension fixieren',
    lockLength: 'Länge',
    lockType: 'Typ',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Berechnen',
    clearButton: 'Alles löschen',
    fields: {
      ceilingHeight: 'Deckenhöhe',
      doorInsulation: 'Türdämmung',
      floorInsulation: 'Bodendämmung',
      glazingArea: 'Verglasungsfläche',
      glazingMode: 'Verglasungsfläche',
      glazingQuality: 'Verglasungsqualität',
      length: 'Länge',
      outerWalls: 'Außenwände',
      projectedDesignTemp: 'Auslegungs-Außentemperatur am Gebäudestandort',
      roofInsulation: 'Dachdämmung',
      roomArea: 'Raumfläche',
      roomFloor: 'Geschoss',
      roomInsulation: 'Dämmstandard',
      roomPreset: 'Raumvorgabe',
      roomTemperature: 'Raumtemperatur',
      roomType: 'Raumtyp',
      uncertaintyFactor: 'Unsicherheitsfaktor',
      ventilation: 'Luftwechsel',
      wallInsulation: 'Wanddämmung',
      width: 'Breite',
      windConditions: 'Windbedingungen',
      windowInsulation: 'Fensterdämmung',
    },
    intro:
      'Ermitteln Sie die überschlägige Heizlast im Raum, um den richtigen Heizkörper aus dem VOGEL&NOOT Heizkörperprogramm auszuwählen.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Mehr als 20%',
        low: 'Weniger als 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Über 20%',
        below_10: 'Unter 10%',
        from_10_to_20: 'Von 10% bis 20%',
        no_windows: 'Ohne Fenster',
      },
      insulationValue: {
        good: 'Gut',
        medium: 'Mittel',
        poor: 'Schlecht',
        very_good: 'Sehr gut',
      },
      qualityValue: {
        modern_excellent: 'Modern (Wärmeschutzglas), ausgezeichnete Energieeffizienz',
        modern_good: 'Modern (Dreifachverglasung), gute Energieeffizienz',
        old_poor: 'Alt (Einscheibenverglasung), geringe Energieeffizienz',
        traditional_medium: 'Traditionell (Doppelverglasung), mittlere Energieeffizienz',
      },
      roomValue: {
        bathroom_24: 'Badezimmer (24 C°)',
        bedroom_20: 'Schlafzimmer (20 C°)',
        garage_12: 'Garage (12 C°)',
        livingroom_22: 'Wohnzimmer (22 C°)',
        storage_16: 'Abstellraum (16 C°)',
      },
      select: 'Auswählen',
      storeyValue: {
        ground_multi: 'Erdgeschoss (Mehrgeschossig)',
        ground_single: 'Erdgeschoss (Eingeschossig)',
        interim: 'Zwischengeschoss',
        top_multi: 'Oberstes Geschoss (Mehrgeschossgebäude)',
      },
      temp: {
        climate_zone_1: '-12 C°',
        climate_zone_2: '-14 C°',
        climate_zone_3: '-16 C°',
        climate_zone_4: '-18 C°',
        climate_zone_5: '-20 C°',
        climate_zone_6: '-22 C°',
        climate_zone_7: '-24 C°',
        climate_zone_8: '-26 C°',
      },
      windInfluence: {
        normal: 'Normal',
        strong: 'Stark',
        weak: 'Schwach',
      },
    },
    roomPresets: {
      bathroom: 'Badezimmer',
      bedroom: 'Schlafzimmer',
      garage: 'Garage',
      kitchen: 'Küche',
      living: 'Wohnzimmer',
      storage: 'Abstellraum',
    },
    sections: {
      dimensions: 'Raummaße',
      insulation: 'Dämmung',
      placement: 'Platzierung',
      result: 'Ergebnis',
      temps: 'Temperaturen',
      ventilation: 'Lüftung',
    },
    title: 'Heizlast Kalkulator',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Übernehmen',
  },
  slider: {
    from: 'Von',
    to: 'Bis',
    value: 'Wert',
  },
}
